import { Banner, DataTable, Text } from '@dixa/lib-shared-habla';

import { BanOnUser } from 'apis/bans';

import { banHistoryColumns, banHistorySubColumns } from './columns';

const bansLoading = <Text.Paragraph>Loading bans history...</Text.Paragraph>;

const bansFailed = (
  <Banner
    variant="fail"
    icon={null}
    description={
      <Text.Paragraph>
        An error occurred while loading bans history
      </Text.Paragraph>
    }
  />
);

const bansEmpty = (
  <Banner
    variant="info"
    icon={null}
    description={
      <Text.Paragraph>
        There are no previous bans on any channels
      </Text.Paragraph>
    }
  />
);

type UserBanHistoryProps = {
  bans: readonly BanOnUser[];
  isLoading: boolean;
  isError: boolean;
};

export const UserBanHistory = ({
  bans,
  isLoading,
  isError,
}: UserBanHistoryProps): JSX.Element | null => {
  if (isError) {
    return bansFailed;
  }

  if (!bans.length) {
    if (isLoading) {
      return bansLoading;
    }

    return bansEmpty;
  }

  return (
    <DataTable<BanOnUser, BanOnUser>
      data={bans}
      columns={banHistoryColumns}
      subTableDataSelector={(data) =>
        data.unbanned_at || data.unbanning_agent_id ? [data] : []
      }
      subTableColumns={banHistorySubColumns}
    />
  );
};
